import $ from 'jquery';

function asideFixed(){
    const carHeight = $('.row.relativePosition').innerHeight(),
        asideFiche = $('.containAsideFiche').innerHeight(),
        aside = $('.containAbsoluteAside');

    let top = $(window).scrollTop() - $('.containIntro').height();
    aside.css('top', top < 0 ? 0 : top );
    if ($(window).scrollTop() >= (carHeight-asideFiche)){
        aside.css({
            'top': 'initial',
            'bottom': 0
        });
    }
}

function enableScrollAside(){
    if ((window.matchMedia('(min-width: 992px)').matches)){
        $(window).on('scroll', asideFixed);
    }
    else {
        $(window).off('scroll', asideFixed);
    }
}

$(document).ready(function () {
    enableScrollAside();
    $(window).resize(function (){
        enableScrollAside();
    });

    $('.btnGoFinancement').click(function () {
        if ((window.matchMedia('(min-width: 1300px)').matches)) {
            $('a[aria-controls="fiche-infos-financement"]').click();
            $('html, body').animate({
                scrollTop: ($('#fiche-infos-financement').offset().top - $('header').outerHeight())
            }, 1000);
        }
        else {
            if (!$('#fiche-infos-financement-collapse').hasClass('in')){
                $('.containInformationsFicheVehicule .panel-collapse').collapse('hide');
                $('#fiche-infos-financement-collapse').collapse('show');
            }
            $('html, body').animate({
                scrollTop: ($('.containInformationsFicheVehicule').offset().top - $('header').outerHeight() + 155)
            }, 1000);

        }
    });

});
